module.exports = __webpack_public_path__ + "static/media/coverage.09275cff.png";